export default "__VITE_ASSET__9VfuJT4K__"